import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import { theme } from 'wisestep-base';

import './index.css';
import App from './App';
//import { initMocks } from './mocks';
import reportWebVitals from './reportWebVitals';
import { setCookieByName, setWorkspaceToken } from './utils/token';

const params = new URLSearchParams(window.location.search.toString());
const auth: string = params.get('auth') ?? '';
const token: string = params.get('token') ?? '';
if (token && auth) {
  setCookieByName('Authorization', auth, 0);
  setWorkspaceToken(token);
  window.history.replaceState(null, '', window.location.pathname);
}

//initMocks();

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
